export { default } from './WhiteLabelTheme';
